/**
 * Created by stonewang on 2017/9/11.
 */
import {config, request} from 'Utils';

//查询渠道赋能列表
export function list(param) {
  return request(`${config.server}/api/v1/dms/information/informationList`, {
    method: 'post',
    body: param,
  });
}
//新增渠道赋能资讯
export function add(param) {
  /*
   {
   content (string, optional): 正文 ,
   imgUrl (string, optional): 图片 ,
   isComment (integer, optional): 是否可评论(0,否，1是) ,
   rangeList (Array[integer], optional): 发布范围ID列表 ,
   title (string, optional): 标题 ,
   type (string, optional): 类型：0渠道政策，1理论学习 ,
   }
   * */
  return request(`${config.server}/api/v1/dms/information/addChannelInfo`, {
    method: 'post',
    body: param,
  });
}
//修改渠道赋能资讯
export function modify(param) {
  /*
   {
   content (string, optional): 正文 ,
   id (integer, optional): 主键ID ,
   imgUrl (string, optional): 图片 ,
   isComment (integer, optional): 是否可评论(0,否，1是) ,
   rangeList (Array[integer], optional): 发布范围ID列表 ,
   title (string, optional): 标题 ,
   type (string, optional): 类型：0渠道政策，1理论学习 ,
   }
   * */
  return request(`${config.server}/api/v1/dms/information/modifyChannelInfo`, {
    method: 'post',
    body: param,
  });
}
//渠道赋能资讯详情
export function detail(param) {
  return request(`${config.server}/api/v1/dms/information/informationDetail?id=${param}`);
}
//发布和撤回接口
export function publishOrDown(param) {
  /*
   {
    ids: [],
    status: 0,
   }
   * */
  return request(`${config.server}/api/v1/dms/information/publishOrDownInfors`, {
    method: 'post',
    body: param,
  });
}

// 渠道赋能资讯评论置顶/首页头条
export function setTop(param) {
  return request(`${config.server}/api/v1/dms/information/inforsCommentTop`, {
    method: 'post',
    body: param,
  });
}
export function getScope() {
  return request(`${config.server}/api/v1/dms/organization/tgTree`);
}


// WEBPACK FOOTER //
// ./src/service/channelFunc/index.js